export const userTypeConfig = [
  {
    label: 'App Support',
    value: 'APP_SUPPORT'
  },
  {
    label: 'App Admin',
    value: 'APP_ADMIN'
  }
];

const AddUserFormDataConfig = [
  {
    key: 'userName',
    label: 'User Name',
    defaultValue: '',
    type: 'email',
    required: true,
    size: 6,
    placeholder: 'Enter User Id',
    rules: {
      required: {
        value: true,
        message: 'User Id is Required'
      },
      pattern: {
        value: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
        message: 'Invalid User Id'
      }
    }
    //   tooltip: tooltipInfo.participant.participantType
  },
  {
    key: 'firstName',
    label: 'First Name',
    defaultValue: '',
    type: 'text',
    size: 6,
    required: true,
    placeholder: 'Enter First Name',
    rules: {
      required: {
        value: true,
        message: 'First Name is Required'
      }
    }
    //   tooltip: tooltipInfo.participant.participantType
  },
  {
    key: 'lastName',
    label: 'Last Name',
    defaultValue: '',
    type: 'text',
    size: 6,
    required: false,
    placeholder: 'Enter Last Name',
    rules: {
      required: {
        value: true,
        message: 'Last Name is Required'
      }
    }
    //   tooltip: tooltipInfo.participant.participantType
  },
  {
    key: 'userType',
    label: 'Select User Type',
    defaultValue: '',
    type: 'dropdown',
    size: 6,
    values: [
      { value: 'PARTICIPANT_SUPPORT', label: 'Participant Support' },
      { value: 'PARTICIPANT_ADMIN', label: 'Participant Admin' }
    ],
    rules: {
      required: {
        value: true,
        message: 'Please select a User Type'
      }
    },
    labelStyleType: 'InputLabel'
  }
];

export const ViewUserFormDataConfig = [
  {
    key: 'User ID',
    label: 'User ID',
    defaultValue: '',
    type: 'email',
    required: true,
    size: 6,
    placeholder: 'Enter User Id',
    rules: {
      required: {
        value: true,
        message: 'User Id is Required'
      },
      pattern: {
        value: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
        message: 'Invalid User Id'
      }
    }
    //   tooltip: tooltipInfo.participant.participantType
  },
  {
    key: 'firstName',
    label: 'First Name',
    defaultValue: '',
    type: 'text',
    size: 6,
    required: true,
    placeholder: 'Enter First Name',
    rules: {
      required: {
        value: true,
        message: 'First Name is Required'
      }
    }
    //   tooltip: tooltipInfo.participant.participantType
  },
  {
    key: 'lastName',
    label: 'Last Name',
    defaultValue: '',
    type: 'text',
    size: 6,
    required: false,
    placeholder: 'Enter Last Name',
    rules: {
      required: {
        value: true,
        message: 'Last Name is Required'
      }
    }
    //   tooltip: tooltipInfo.participant.participantType
  },
  {
    key: 'userType',
    label: 'Select User Type',
    defaultValue: '',
    type: 'dropdown',
    size: 6,
    required: true,
    placeholder: 'Select User Type',
    values: userTypeConfig,
    rules: {
      required: {
        value: true,
        message: 'User Type is Required'
      }
    }
    //   tooltip: tooltipInfo.participant.participantType
  }
];

export const usersColumns = [
  {
    title: 'User ID',
    field: 'userName',
    headerStyle: { zIndex: 11 },
    width: '20%'
  },
  {
    title: 'First Name',
    field: 'firstName',
    width: '20%',
    headerStyle: { zIndex: 11 }
  },
  {
    title: 'Last Name',
    field: 'lastName',
    width: '20%',
    headerStyle: { zIndex: 11 }
  },
  {
    title: 'Status',
    width: '20%',
    field: 'status',
    headerStyle: { zIndex: 11 }
  }
];

export default AddUserFormDataConfig;
